import React, { createContext, useState, useEffect, useContext } from 'react';

const HierarchyProductsLocalStorageContext = createContext(null);

export const HierarchyProductsLocalStorageProvider = ({ children }) => {
    const [hierarchyProductsLocalStorageValue, setHierarchyLocalStorageValue] =
        useState({
            products: JSON.parse((localStorage.getItem('Premmiar@:products')))?.length
                ? JSON.parse((localStorage.getItem('Premmiar@:products')))
                : []
        })

    useEffect(() => {
        localStorage.setItem('Premmiar@:products', JSON.stringify(hierarchyProductsLocalStorageValue.products))

    }, [hierarchyProductsLocalStorageValue])

    return (
        <HierarchyProductsLocalStorageContext.Provider value={{ hierarchyProductsLocalStorageValue, setHierarchyLocalStorageValue }}>
            {children}
        </HierarchyProductsLocalStorageContext.Provider>
    );
};

export const useHierarchyProductsLocalStorageContext = () => useContext(HierarchyProductsLocalStorageContext);